export default __webpack_public_path__ + "static/media/Roboto-Light.a41e30c8.woff2";